/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  BulkMoveFolderDocumentsResponseData,
  BulkMoveFolderDocumentsResponseDataFromJSON,
  BulkMoveFolderDocumentsResponseDataFromJSONTyped,
  BulkMoveFolderDocumentsResponseDataToJSON
} from './BulkMoveFolderDocumentsResponseData'

/**
 *
 * @export
 * @interface ChangeUserContactsEmailTransactionsResponse
 */
export interface ChangeUserContactsEmailTransactionsResponse {
  /**
   *
   * @type {BulkMoveFolderDocumentsResponseData}
   * @memberof ChangeUserContactsEmailTransactionsResponse
   */
  data?: BulkMoveFolderDocumentsResponseData
}

export function ChangeUserContactsEmailTransactionsResponseFromJSON(
  json: any
): ChangeUserContactsEmailTransactionsResponse {
  return ChangeUserContactsEmailTransactionsResponseFromJSONTyped(json, false)
}

export function ChangeUserContactsEmailTransactionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChangeUserContactsEmailTransactionsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data') ? undefined : BulkMoveFolderDocumentsResponseDataFromJSON(json['data'])
  }
}

export function ChangeUserContactsEmailTransactionsResponseToJSON(
  value?: ChangeUserContactsEmailTransactionsResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: BulkMoveFolderDocumentsResponseDataToJSON(value.data)
  }
}
